<template>
    <basic-container>
        <div class="managing-staff">
            <!-- 搜索区域 -->
            <div class="search-area">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="姓名：">
                        <el-input v-model="searchForm.name" placeholder="请输入" style="width: 180px;"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：">
                        <el-input v-model="searchForm.phone" placeholder="请输入" style="width: 180px;"
                            @input="handlePhoneInput('search')"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" icon="el-icon-refresh" @click="handleReset">清空</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 操作按钮区域 -->
            <div class="action-area">
                <el-button type="text" icon="el-icon-delete" @click="handleBatchDelete"
                    :disabled="selectedRows.length === 0">批量删除</el-button>
                <el-button type="text" icon="el-icon-edit" plain @click="handleUploadAgreement">编辑合作协议模板</el-button>
                <el-button type="text" icon="el-icon-plus" @click="handleAdd">新增</el-button>
            </div>

            <!-- 表格区域 -->
            <div class="table-area">
                <el-table :data="staffList" style="width: 100%" border ref="multipleTable"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="姓名" min-width="120"></el-table-column>
                    <el-table-column prop="phone" label="手机号" min-width="150"></el-table-column>
                    <el-table-column prop="agreement" label="承揽合作协议" min-width="200">
                        <template slot-scope="scope">
                            <!-- 确保任意状态都显示协议 -->
                            <div class="agreement-wrapper" :class="['agreement-status-' + scope.row.status]"
                                @click="previewAgreement(scope.row)">
                                <i class="el-icon-document"></i>
                                <span class="file-name-text" :title="scope.row.name + '的协议文件' || '协议文件'">
                                    {{ scope.row.name + '的协议文件' || '协议文件' }}
                                </span>
                                <!-- 未签约状态样式 -->
                                <!-- <span v-if="scope.row.status === 1" class="status-badge">未签约</span> -->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="签约状态" min-width="120">
                        <template slot-scope="scope">
                            <el-tag :type="getStatusType(scope.row.status)">{{ statusMap[scope.row.status] }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" min-width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180" fixed="right">
                        <template slot-scope="scope">
                            <!-- 审核中状态显示通过和拒绝按钮 -->
                            <div style="margin-top: 5px; display: flex; gap: 5px;">
                                <el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.row)"
                                size="small">删除</el-button>
                                <el-button v-if="scope.row.status === 2" type="text" icon="el-icon-check"
                                    @click.stop="handleApprove(scope.row, 3)" size="small"
                                    style="color: #67c23a;">通过</el-button>
                                <el-button v-if="scope.row.status === 2" type="text" icon="el-icon-close"
                                    @click.stop="handleReject(scope.row, 4)" size="small"
                                    style="color: #f56c6c;">拒绝</el-button>
                                <el-button v-if="scope.row.status === 3" type="text" icon="el-icon-close"
                                    @click.stop="handleReject(scope.row, 2)" size="small"
                                    style="color: #ff9900;">退回</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页区域 -->
            <div class="pagination-area">
                <div class="pagination-info">
                    共 {{ pageInfo.total }} 条
                </div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageInfo.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.total"></el-pagination>
            </div>

            <!-- 上传承揽合作协议弹窗 -->
            <el-dialog title="承揽合作协议模板" :visible.sync="uploadAgreementVisible" @close="handleUploadClose" fullscreen>
                <el-form :model="uploadForm" :rules="uploadRules" ref="uploadForm">
                    <div class="template-info">
                        <el-alert title="提示" type="info" description="请在下方编辑器中编辑承揽合作协议模板内容，保存后将作为公司标准模板使用。"
                            show-icon></el-alert>
                        <div v-if="contractTemplate" class="template-meta">
                            <el-tag size="small" type="info">模板ID: {{ contractTemplate.id }}</el-tag>
                            <el-tag size="small" v-if="contractTemplate.createTime">创建时间: {{ contractTemplate.createTime
                            }}</el-tag>
                            <el-tag size="small" v-if="contractTemplate.updateTime" type="success">更新时间: {{
                                contractTemplate.updateTime }}</el-tag>
                        </div>
                    </div>
                    <el-form-item label="协议内容" prop="richTextContent">
                        <quill-editor v-model="uploadForm.richTextContent" ref="myQuillEditor" :options="editorOption"
                            style="height: 1000px;" @blur="onEditorBlur" @focus="onEditorFocus"
                            @ready="onEditorReady"></quill-editor>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-close" @click="handleUploadClose">取消</el-button>
                    <el-button type="text" icon="el-icon-check" @click="confirmUpload"
                        :loading="isUploading">确定</el-button>
                </div>
            </el-dialog>

            <!-- 新增弹窗 -->
            <el-dialog title="新增" :visible.sync="addDialogVisible" width="500px" :close-on-click-modal="false">
                <el-form :model="addForm" :rules="addRules" ref="addFormRef">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="addForm.phone" placeholder="请输入手机号"
                            @input="handlePhoneInput('add')"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-close" @click="addDialogVisible = false">取消</el-button>
                    <el-button type="text" icon="el-icon-check" @click="confirmAdd">确定</el-button>
                </span>
            </el-dialog>

            <!-- 协议查看弹窗 -->
            <el-dialog :title="previewTitle" :visible.sync="previewDialogVisible" fullscreen append-to-body
                :custom-class="dialogCustomClass" :close-on-click-modal="false" :close-on-press-escape="false" top="2vh"
                center>
                <div v-if="currentPreviewData" class="preview-dialog-content">
                    <!-- 协议内容展示区域（包含甲乙方信息） -->
                    <div class="agreement-content"
                        :data-status="currentPreviewData ? statusMap[currentPreviewData.status] : ''">
                        <div v-if="completeAgreementContent" class="rich-text-display"
                            v-html="completeAgreementContent"></div>
                        <div v-else-if="currentPreviewData.agreementUrl" class="agreement-url">
                            <a :href="currentPreviewData.agreementUrl" target="_blank">点击查看协议文件</a>
                        </div>
                        <div v-else class="no-content">暂无协议内容可查看</div>
                    </div>
                </div>

                <!-- 底部操作按钮 -->
                <div slot="footer" class="dialog-footer">
                    <!-- 只在status=1（未签约）时显示审核/拒绝按钮 -->
                    <template v-if="currentPreviewData && currentPreviewData.status == 2">
                        <el-button type="text" icon="el-icon-close"
                            @click="handleReject(currentPreviewData, 4)">拒绝</el-button>
                        <el-button type="text" icon="el-icon-check"
                            @click="handleApprove(currentPreviewData, 3)">通过</el-button>
                    </template>
                    <el-button type="text" icon="el-icon-close" @click="previewDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </basic-container>
</template>
<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getContractTemplate, addContractTemplate, editContractTemplate, addContractPerson, getContractPersonList, passOrNoContract, getContractPersonDetail, deleteContract } from '@/api/salesCloud/managingStaff/managingStaff'
export default {
    name: 'ManagingStaff',
    components: {
        quillEditor
    },
    computed: {
        // 动态生成dialog的自定义类名（字符串格式）
        dialogCustomClass() {
            let classes = 'agreement-dialog';
            if (this.currentPreviewData) {
                switch (this.currentPreviewData.status) {
                    case 1:
                        classes += ' status-pending';
                        break;
                    case 2:
                        classes += ' status-reviewing';
                        break;
                    case 3:
                        classes += ' status-completed';
                        break;
                    case 4:
                        classes += ' status-rejected';
                        break;
                }
            }
            return classes;
        },
        // 生成包含甲乙方信息的完整HTML内容
        completeAgreementContent() {
            if (!this.currentPreviewData) return '';

            // 甲乙方信息HTML
            const partyInfoHtml = `
                <div style="margin-bottom: 30px;">
                    <h3 style="font-size: 18px; color: #303133; margin: 0 0 15px 0;">甲乙方信息</h3>
                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 1px solid #ebeef5;">
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">甲方（委托人）：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.companyName || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">统一社会信用代码：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.socialCreditCode || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">地址：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.companyAddress || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">联系电话：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.companyPhone || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">乙方（承揽人）：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.userName || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">身份证号码：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.idCard || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">地址：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.address || ''}</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; font-weight: 500; color: #606266; width: 30%; background-color: #fafafa;">手机号码：</td>
                            <td style="border: 1px solid #ebeef5; padding: 12px 16px; color: #303133;">${this.currentPreviewData.phone || ''}</td>
                        </tr>
                    </table>
                </div>
                <hr style="margin: 20px 0; border: 1px solid #e0e0e0;" />
            `;

            // 格式化日期函数
            const formatDate = (dateStr) => {
                if (!dateStr) return '_______年_______月_______日';
                try {
                    const date = new Date(dateStr);
                    const year = date.getFullYear();
                    // 注意：这里日期减1
                    const month = date.getMonth() + 1;
                    const day = date.getDate() - 1;
                    return `${year}年${month}月${day}日`;
                } catch (e) {
                    console.error('日期格式化失败:', e);
                    return '_______年_______月_______日';
                }
            };

            // 甲乙方签字/盖章区域HTML
            const signatureHtml = `
                <hr style="margin: 30px 0; border: 1px solid #e0e0e0;" />
                <div style="display: flex; justify-content: flex-end; margin-top: 40px;">
                    <div style="display: flex; flex-direction: column; gap: 30px; width: 400px;">
                        <div style="text-align: left;">
                            <h4 style="margin: 0 0 15px 0;">甲方（委托人）</h4>
                            <div>
                                <div>
                                    <span>（签字/盖章）</span>
                                </div>
                                <div style="margin-top: 10px; font-size: 14px; color: #606266;">
                                    <span>签订日期：${formatDate(this.currentPreviewData.signingDate)}</span>
                                </div>
                            </div>
                        </div>
                        <div style="text-align: left;">
                            <h4 style="margin: 0 0 15px 0;">乙方（承揽人）</h4>
                            <div>
                                <div>
                                    <span>${this.currentPreviewData.userName || this.currentPreviewData.name || '待完善'}（签字/盖章）</span>
                                    ${this.currentPreviewData.consigneePic ? `
                                    <div style="margin-top: 10px;">
                                        <img src="${this.currentPreviewData.consigneePic}" alt="乙方签字图片" onclick="window.open('${this.currentPreviewData.consigneePic}', '_blank')" style="max-width: 200px; max-height: 150px; border: 1px solid #e0e0e0; border-radius: 4px; cursor: pointer; transition: all 0.3s ease;">
                                        <div style="margin-top: 5px; font-size: 12px; color: #909399;">点击查看大图</div>
                                    </div>
                                    ` : ''}
                                </div>
                                <div style="margin-top: 10px; font-size: 14px; color: #606266;">
                                    <span>签订日期：${formatDate(this.currentPreviewData.signingDate)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            // 返回完整内容（甲乙方信息 + 原协议内容 + 签字/盖章区域）
            return partyInfoHtml + (this.currentPreviewData.content || '') + signatureHtml;
        }
    },
    data() {
        return {
            // 搜索表单
            searchForm: {
                name: '',
                phone: ''
            },
            // 表格数据
            staffList: [],
            // 分页信息
            pageInfo: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 上传弹窗
            uploadAgreementVisible: false,
            uploadForm: {
                richTextContent: ''
            },
            uploadRules: {
                richTextContent: [
                    { required: true, message: '请输入协议内容', trigger: 'blur' }
                ]
            },
            contractTemplate: null, // 当前合同模板信息
            isLoadingTemplate: false, // 加载模板状态
            isUploading: false,
            // Quill编辑器配置
            editorOption: {
                theme: 'snow',
                placeholder: '请输入协议内容',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'align': [] }],
                        ['clean']
                    ]
                }
            },
            // 新增弹窗
            addDialogVisible: false,
            addForm: {
                name: '',
                phone: ''
            },
            addRules: {
                name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ]
            },

            // 状态映射
            statusMap: {
                1: '未签约',
                2: '审核中',
                3: '完成',
                4: '已退回'
            },
            // 预览弹窗相关
            previewDialogVisible: false,
            currentPreviewData: null,
            previewTitle: '',
            // 选中的行数据（用于批量删除）
            selectedRows: []
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        // 加载数据
        async loadData() {
            try {
                // 构建请求参数
                const params = {
                    name: this.searchForm.name,
                    phone: this.searchForm.phone,
                    page: this.pageInfo.currentPage,
                    size: this.pageInfo.pageSize
                }

                const response = await getContractPersonList(params)
                if (response.code == '200' && response.data) {
                    // 解析数据（注意：接口返回的data可能是JSON字符串）
                    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data

                    // 处理返回的数据
                    const processedData = (data.rows || []).map(item => ({
                        ...item,
                        // 确保name存在
                        name: item.name || (item.pdfUrl ? '协议文件.pdf' : null),
                        // 确保content存在
                        content: item.content || '',
                        // 映射URL字段
                        agreementUrl: item.pdfUrl || null
                    }))

                    this.staffList = processedData
                    this.pageInfo.total = data.total || 0
                }
            } catch (error) {
                console.error('加载劳务人员列表失败:', error)
                this.$message.error('加载数据失败，请重试')
                // 出错时使用空数据
                this.staffList = []
                this.pageInfo.total = 0
            }
        },
        // 搜索
        handleSearch() {
            // 搜索逻辑
            this.pageInfo.currentPage = 1
            this.loadData()
        },
        // 重置
        handleReset() {
            this.searchForm = {
                name: '',
                phone: ''
            }
            this.pageInfo.currentPage = 1
            this.loadData()
        },
        // 手机号输入处理
        handlePhoneInput(formType) {
            // 只允许输入数字
            if (formType === 'search') {
                this.searchForm.phone = this.searchForm.phone.replace(/[^0-9]/g, '')
            } else if (formType === 'add') {
                this.addForm.phone = this.addForm.phone.replace(/[^0-9]/g, '')
            }
        },
        // 上传协议
        async handleUploadAgreement() {
            this.uploadAgreementVisible = true
            this.uploadForm.richTextContent = ''
            this.contractTemplate = null

            // 加载合同模板
            this.loadContractTemplate()
        },

        // 加载合同模板
        async loadContractTemplate() {
            this.isLoadingTemplate = true
            try {
                const response = await getContractTemplate()
                if (response.code === '200' && response.data) {
                    // 解析数据（注意：接口返回的data是JSON字符串）
                    const templateData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
                    this.contractTemplate = templateData
                    if (templateData.content) {
                        this.uploadForm.richTextContent = templateData.content
                    }
                }
            } catch (error) {
                console.error('加载合同模板失败:', error)
                this.$message.error('加载合同模板失败')
            } finally {
                this.isLoadingTemplate = false
            }
        },

        // 确认上传
        confirmUpload() {
            this.$refs.uploadForm.validate(async (valid) => {
                if (valid) {
                    this.isUploading = true;
                    try {
                        // 准备提交数据
                        const submitData = {
                            content: this.uploadForm.richTextContent
                        };
                        console.log('index.vue ~ line: 369 ~ submitData ->', submitData);
                        console.log('index.vue ~ line: 370 ~ this.contractTemplate ->', this.contractTemplate);


                        let response;
                        if (this.contractTemplate && this.contractTemplate.id) {
                            const params = {
                                ...this.contractTemplate,
                                content: submitData.content
                            }
                            console.log('index.vue ~ line: 373 ~ params ->', params);
                            response = await editContractTemplate(params);
                        } else {
                            response = await addContractTemplate(submitData);
                        }

                        if (response.code === '200') {
                            this.$message.success(this.contractTemplate ? '协议修改成功' : '协议新增成功');
                            this.handleUploadClose();
                        } else {
                            this.$message.error(response.message || '保存失败');
                        }
                    } catch (error) {
                        console.error('保存合同模板失败:', error);
                        this.$message.error('保存失败，请重试');
                    } finally {
                        this.isUploading = false;
                    }
                }
            });
        },

        // 处理上传弹窗关闭
        handleUploadClose() {
            this.uploadAgreementVisible = false;
            if (this.$refs.uploadForm) {
                this.$refs.uploadForm.resetFields();
            }
            this.uploadForm.richTextContent = '';
            this.contractTemplate = null;
        },
        // Quill编辑器相关方法
        onEditorBlur(editor) {
            // 编辑器失去焦点时的处理
            console.log('editor blur!', editor)
        },
        onEditorFocus(editor) {
            // 编辑器获得焦点时的处理
            console.log('editor focus!', editor)
        },
        onEditorReady(editor) {
            // 编辑器初始化完成时的处理
            console.log('editor ready!', editor)
        },
        // 处理表格选择变化
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        // 处理单个删除
        async handleDelete(row) {
            try {
                await this.$confirm('确定要删除该员工信息吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                const success = await this.deleteStaff(row.id);
                if (success) {
                    this.$message.success('删除成功');
                }
            } catch (error) {
                // 用户取消删除
                if (error !== 'cancel') {
                    console.error('删除操作失败:', error);
                }
            }
        },
        // 处理批量删除
        async handleBatchDelete() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择要删除的员工');
                return;
            }

            try {
                await this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 名员工信息吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                // 批量删除时，将所有选中的id合并成一个字符串，使用逗号分隔
                const idsToDelete = this.selectedRows.map(row => row.id).join(',');

                try {
                    // 直接调用deleteContract API进行批量删除
                    await deleteContract(idsToDelete);
                    // 删除成功后重新加载数据
                    await this.loadData();
                    this.$refs.multipleTable.clearSelection();
                    this.$message.success('批量删除成功');
                } catch (error) {
                    console.error('批量删除失败:', error);
                    this.$message.error('批量删除失败，请稍后重试');
                }
            } catch (error) {
                // 用户取消删除
                if (error !== 'cancel') {
                    console.error('批量删除操作失败:', error);
                }
            }
        },
        // 删除员工的实际逻辑
        async deleteStaff(id) {
            try {
                console.log('删除员工ID:', id);
                // 调用删除API
                await deleteContract(id);
                // 删除成功后重新加载数据
                await this.loadData();
                return true;
            } catch (error) {
                console.error('删除失败:', error);
                this.$message.error('删除失败，请稍后重试');
                return false;
            }
        },
        // 新增
        handleAdd() {
            this.addForm = {
                name: '',
                phone: ''
            }
            this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
            this.addDialogVisible = true
        },
        // 确认新增
        confirmAdd() {
            this.$refs.addFormRef.validate(async (valid) => {
                if (valid) {
                    try {
                        // 准备提交数据
                        const submitData = {
                            name: this.addForm.name,
                            phone: this.addForm.phone
                        }

                        console.log('提交新增劳务人员数据:', submitData)

                        // 调用API保存数据
                        const response = await addContractPerson(submitData)

                        if (response.code == '200') {
                            this.$message.success('新增成功')
                            this.addDialogVisible = false
                            // 重新加载数据
                            this.pageInfo.currentPage = 1
                            this.loadData()
                        } else {
                            this.$message.error(response.message || '新增失败')
                        }
                    } catch (error) {
                        console.error('新增劳务人员失败:', error)
                        this.$message.error('操作失败，请重试')
                    }
                }
            })
        },
        // 预览协议
        async previewAgreement(row) {
            // 设置弹窗标题
            this.previewTitle = `${row.name || '协议文件'} - 承揽合作协议`;

            try {
                // 调用接口获取详细数据
                const response = await getContractPersonDetail(row.id);
                if (response.code == '200' && response.data) {
                    // 解析数据（注意：接口返回的data是JSON字符串）
                    const detailData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                    console.log('index.vue ~ line: 781 ~ detailData ->', detailData);
                    // 设置预览数据
                    this.currentPreviewData = detailData;
                } else {
                    // 如果获取详情失败，使用表格中的数据
                    this.currentPreviewData = row;
                    this.$message.warning('获取详细信息失败，显示基础数据')
                }
            } catch (error) {
                console.error('获取协议详情失败:', error);
                // 出错时使用表格中的数据
                this.currentPreviewData = row;
                this.$message.warning('获取详细信息失败，显示基础数据')
            } finally {
                // 打开弹窗
                this.previewDialogVisible = true;

                // 如果既没有content也没有url，给出提示
                if (!this.currentPreviewData.content && !this.currentPreviewData.agreementUrl) {
                    this.$message.warning('暂无协议内容可查看')
                }
            }
        },
        // 获取状态标签类型
        getStatusType(status) {
            const typeMap = {
                1: 'primary',
                2: 'info',
                3: 'success',
                4: 'danger'
            }
            return typeMap[status] || 'info'
        },

        // 处理审核通过
        async handleApprove(row, status) {
            this.$confirm('确定要通过该协议的审核吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    // 实际实现时应该调用相应的API
                    const response = await passOrNoContract({
                        ...row,
                        status: status
                    })
                    if (response.code == '200') {
                        // 成功后关闭弹窗并刷新数据
                        this.previewDialogVisible = false
                        this.loadData()
                        this.$message.success('审核通过成功')
                    } else {
                        this.$message.error(response.message || '操作失败')
                    }
                } catch (error) {
                    console.error('审核通过失败:', error)
                    this.$message.error('审核失败，请重试')
                }
            }).catch(() => {
                // 用户取消操作
            })
        },

        // 处理审核拒绝
        async handleReject(row, status) {
            this.$confirm('确定要拒绝该协议的审核吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    // 模拟API调用
                    console.log('审核拒绝:', row.id)
                    // 实际实现时应该调用相应的API
                    const response = await passOrNoContract({
                        ...row,
                        status: status
                    })
                    if (response.code == '200') {
                        // 成功后关闭弹窗并刷新数据
                        this.previewDialogVisible = false
                        this.loadData()
                        this.$message.success('审核拒绝成功')
                    } else {
                        this.$message.error(response.message || '操作失败')
                    }
                } catch (error) {
                    console.error('审核拒绝失败:', error)
                    this.$message.error('操作失败，请重试')
                }
            }).catch(() => {
                // 用户取消操作
            })
        },
        // 分页大小改变
        handleSizeChange(size) {
            this.pageInfo.pageSize = size
            this.loadData()
        },
        // 当前页码改变
        handleCurrentChange(current) {
            this.pageInfo.currentPage = current
            this.loadData()
        }
    }
}
</script>

<style scoped>
.managing-staff {
    padding: 20px;
    background-color: #fff;
}

.search-area {
    margin-bottom: 20px;
}

.action-area {
    margin-bottom: 20px;
    text-align: right;
}

.table-area {
    margin-bottom: 20px;
}

.pagination-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pagination-info {
    color: #606266;
}

/* 输入框样式优化 */
.el-input__inner {
    border-radius: 4px;
}

/* 富文本编辑器样式 */
.rich-text-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
}

.rich-text-editor .el-textarea__inner {
    border: none;
    resize: vertical;
}

/* Quill编辑器样式优化 */
.ql-toolbar.ql-snow {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom: 0;
}

.ql-container.ql-snow {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px solid #dcdfe6;
    min-height: 200px;
}

.ql-editor {
    min-height: 200px;
}

/* 按钮样式优化 */
.el-button {
    margin-left: 10px;
}

.el-button:first-child {
    margin-left: 0;
}

/* 表格样式优化 */
.el-table {
    border: 1px solid #ebeef5;
}

.el-table th,
.el-table td {
    padding: 12px 0;
}

/* 分页样式优化 */
.el-pagination {
    margin: 0;
}

.file-name-text {
    margin-left: 5px;
    font-size: 14px;
    color: #409eff;
    max-width: 150px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 协议容器样式 */
.agreement-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.3s;
}

.agreement-wrapper:hover {
    background-color: #f5f7fa;
}

/* 未签约状态样式 */
.agreement-status-1 .file-name-text {
    color: #606266;
}

.agreement-status-1 .el-icon-document {
    color: #606266;
}

/* 审核中状态样式 */
.agreement-status-2 .file-name-text {
    color: #e6a23c;
}

.agreement-status-2 .el-icon-document {
    color: #e6a23c;
}

/* 已完成状态样式 */
.agreement-status-3 .file-name-text {
    color: #67c23a;
}

.agreement-status-3 .el-icon-document {
    color: #67c23a;
}

/* 已退回状态样式 */
.agreement-status-4 .file-name-text {
    color: #f56c6c;
}

.agreement-status-4 .el-icon-document {
    color: #f56c6c;
}

/* 状态标记样式 */
.status-badge {
    margin-left: 8px;
    padding: 2px 6px;
    font-size: 12px;
    background-color: #f56c6c;
    color: white;
    border-radius: 10px;
}

.template-info {
    margin-bottom: 20px;
}

.template-meta {
    margin-top: 15px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.template-meta .el-tag {
    margin-bottom: 5px;
}

/* 预览弹窗样式 */
.preview-dialog-content {
    padding: 20px;
    background-color: #fff;
    transition: all 0.3s ease;
}

/* 弹窗动画效果 */
.agreement-dialog .el-dialog__wrapper {
    transition: opacity 0.3s ease;
}

.agreement-dialog .el-dialog {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.agreement-dialog .el-dialog:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

/* 按钮样式优化 */
.dialog-footer .el-button {
    transition: all 0.3s ease;
    margin-left: 10px;
}

.dialog-footer .el-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 甲乙方信息hover效果 */
.party-info-item {
    transition: background-color 0.2s ease;
    padding: 8px 0;
}

.party-info-item:hover {
    background-color: rgba(64, 158, 255, 0.05);
}

/* 滚动条样式优化 */
.rich-text-display::-webkit-scrollbar,
.el-dialog__body::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.rich-text-display::-webkit-scrollbar-track,
.el-dialog__body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.rich-text-display::-webkit-scrollbar-thumb,
.el-dialog__body::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 4px;
    transition: background 0.3s ease;
}

.rich-text-display::-webkit-scrollbar-thumb:hover,
.el-dialog__body::-webkit-scrollbar-thumb:hover {
    background: #909399;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
    .agreement-dialog .el-dialog {
        width: 95% !important;
        margin: 0;
        top: 50% !important;
        transform: translateY(-50%);
    }

    .party-info-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .party-info-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .party-label {
        width: 100%;
        margin-bottom: 5px;
    }
}

/* 甲乙方信息样式 */
.party-info {
    margin-bottom: 30px;
    padding: 20px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}

.party-info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.party-info-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.status-tag {
    font-size: 18px;
}

/* 不同状态的弹窗样式 */
.status-pending .el-dialog__header {
    border-bottom-color: #e6a23c;
    background-color: #fdf6ec;
}

.status-reviewing .el-dialog__header {
    border-bottom-color: #67c23a;
    background-color: #f0f9eb;
}

.status-completed .el-dialog__header {
    border-bottom-color: #409eff;
    background-color: #ecf5ff;
}

.status-rejected .el-dialog__header {
    border-bottom-color: #f56c6c;
    background-color: #fef0f0;
}

/* 状态徽章装饰 */
.agreement-content {
    position: relative;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    min-height: 800px;
}

/* 状态水印效果 */
.agreement-content::after {
    content: attr(data-status);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-15deg);
    font-size: 80px;
    font-weight: bold;
    opacity: 0.05;
    pointer-events: none;
    z-index: 1;
}

.party-info-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 1.6;
}

.party-info-item:last-child {
    margin-bottom: 0;
}

.party-label {
    width: 120px;
    font-weight: 500;
    color: #303133;
    flex-shrink: 0;
}

.party-value {
    color: #606266;
    flex: 1;
    word-break: break-all;
}

/* 协议内容样式 */
.agreement-content {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    min-height: 400px;
}

.rich-text-display {
    font-size: 14px;
    line-height: 1.8;
    color: #303133;
    min-height: 800px;
    overflow-y: auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
}

/* 表格样式已移除，使用内联style */

.rich-text-display h1,
.rich-text-display h2,
.rich-text-display h3 {
    margin-top: 20px;
    margin-bottom: 15px;
    color: #303133;
}

.rich-text-display p {
    margin-bottom: 10px;
    text-align: justify;
}

.rich-text-display ul,
.rich-text-display ol {
    margin-bottom: 15px;
    padding-left: 25px;
}

/* 无内容样式 */
.no-content {
    padding: 50px 0;
    text-align: center;
}

/* 签字区域样式已移除，使用内联style */

/* 弹窗底部样式 */
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 15px 20px;
    border-top: 1px solid #ebeef5;
    background-color: #fff;
}

/* 全屏弹窗优化 */
.el-dialog__body {
    padding: 0 !important;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
}

.el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    background-color: #fafafa;
}
</style>